import { useEffect, useState } from "react";
import { Icon } from "@iconify/react/dist/iconify.js";
import {
  previewDiplomaPDF,
  downloadDiplomaPDF,
} from "../../../utils/generateDiplomaPDF";
import "./css/certificadoModal.css";

const DiplomaModal = ({ open, onClose, nombre, talentos }) => {
  const [url, setUrl] = useState(null);
  const [loading, setLoading] = useState(false);
  const [downloading, setDownloading] = useState(false);

  const isMobile =
    typeof window !== "undefined" &&
    window.matchMedia?.("(max-width: 768px)").matches;

  useEffect(() => {
    if (!open || isMobile) return;

    let revokeUrl = null;
    let cancelled = false;

    (async () => {
      setLoading(true);
      const blobUrl = await previewDiplomaPDF({ nombre, talentos });
      if (cancelled) {
        if (blobUrl) URL.revokeObjectURL(blobUrl);
        return;
      }
      revokeUrl = blobUrl;
      setUrl(blobUrl);
      setLoading(false);
    })();

    return () => {
      cancelled = true;
      if (revokeUrl) URL.revokeObjectURL(revokeUrl);
      setUrl(null);
    };
  }, [open, isMobile, nombre, talentos]);

  useEffect(() => {
    if (!open || !isMobile) return;
    (async () => {
      try {
        await downloadDiplomaPDF({ nombre, talentos });
      } finally {
        onClose?.();
      }
    })();
  }, [open, isMobile, nombre, talentos, onClose]);

  useEffect(() => {
    if (!open || isMobile) return;
    const onKey = (e) => {
      if (e.key === "Escape") onClose?.();
    };
    document.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = "";
    };
  }, [open, isMobile, onClose]);

  const handleDownload = async () => {
    setDownloading(true);
    try {
      await downloadDiplomaPDF({ nombre, talentos });
    } finally {
      setDownloading(false);
    }
  };

  if (!open || isMobile) return null;

  return (
    <div className="certificado-modal-backdrop" onClick={onClose}>
      <div
        className="certificado-modal"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
      >
        <div className="certificado-modal__header">
          <div className="certificado-modal__title">
            <Icon icon="mdi:certificate" />
            <span>Vista previa del certificado</span>
          </div>
          <button
            type="button"
            className="certificado-modal__close"
            onClick={onClose}
            aria-label="Cerrar"
          >
            <Icon icon="mdi:close" />
          </button>
        </div>

        <div className="certificado-modal__body">
          {loading || !url ? (
            <div className="certificado-modal__loading">
              <div className="certificado-modal__spinner" />
              <span>Generando certificado...</span>
            </div>
          ) : (
            <iframe
              title="Diploma"
              src={url}
              className="certificado-modal__iframe"
            />
          )}
        </div>

        <div className="certificado-modal__footer">
          <button
            type="button"
            className="certificado-modal__btn certificado-modal__btn--ghost"
            onClick={onClose}
          >
            Cerrar
          </button>
          <button
            type="button"
            className="certificado-modal__btn certificado-modal__btn--primary"
            onClick={handleDownload}
            disabled={loading || downloading}
          >
            {downloading ? (
              <>
                <span className="certificado-modal__spinner certificado-modal__spinner--sm" />
                Descargando...
              </>
            ) : (
              <>
                <Icon icon="mdi:download" />
                Descargar certificado
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DiplomaModal;
